import { createFileRoute } from "@tanstack/react-router"
import { getTypedQueryData } from "../../../../typed-client/get-typed-query-data"
import { lazyImportRouteComponent } from "../../../../utils/lazyImportRouteComponent"

export const Route = createFileRoute("/app/admin-settings/users/$id")({
  component: lazyImportRouteComponent(
    () => import("./-components/UserPage"),
    "UserPage"
  ),
  beforeLoad: (context) => {
    const user =
      context.context.queryClient &&
      getTypedQueryData(context.context.queryClient, "/api/User/GetUser", {
        userId: parseInt(context.params.id),
      })

    return { getTitle: () => user?.userName }
  },
})
